import { State } from '@sc/portal.fe.lib.app-components';
import { BasicModel } from './basic.model';

export class RiskLocation extends BasicModel<RiskLocation> {
    addressLine1?: string;
    addressLine2?: string;
    addressLine3?: string;
    addressType?: string;
    city?: { code: string, description: string };
    country?: string;
    postalCode?: string;
    publicId?: string;
    state?: State;
    streetNumber?: string;
}
